import { and, email, helpers, not } from "vuelidate/lib/validators";

type ValidationErrors = Record<string, Array<string>>;

export const backendErrors = (errors: ValidationErrors) => {
  const defaultError = "noMatch";
  const mapper: Record<string, string> = {
    REGISTRATION_UNIQUE_FORMAT: "alreadyExists",
    TOKEN_MISMATCH: "tokenMismatch",
    EMAIL_DISPOSABLE: "emailDisposable",
    email_used: "email_used",
    phone_number_used: "alreadyExists",
    unknown_error: "unknown_error",
    trading_panel_request_exist: "trading_panel_request_exist"
  };

  const fields = Object.keys(errors);
  if (fields.length === 0) {
    return null;
  }

  const fieldErrors: Record<string, string> = {};

  fields.forEach(field => {
    const errorKey = errors[field][0];
    fieldErrors[field] = mapper[errorKey] || defaultError;
  });

  return fieldErrors;
};

export const overrideFieldError = function(
  errors: any,
  field: string,
  defaultError: string
) {
  errors = errors || {};

  const fields = Object.keys(errors);

  if (fields.indexOf(field) >= 0) {
    return {
      [field]: errors[field]
    };
  }

  return {
    [field]: [defaultError]
  };
};

export const latinValidator = helpers.regex("name", /^[a-zA-Z .-]*$/);
export const trueValidator = (value: boolean) => value;

export const emailValidator = and(
  // @ts-ignore
  email,
  not(helpers.regex("cyrillic", /[а-яА-ЯЁё]/))
);

export const trBackendErrorsCode = (field_codes: any) => {
  if (!field_codes) {
    return null;
  }

  let fields = Object.keys(field_codes);
  if (fields.length == 0 || fields[0].length == 0) {
    return null;
  }

  let field = fields[0];
  return field + "_" + field_codes[field][0];
};
